export function isClient() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

export function isBannerPlatform(platform) {
  const bannerPlatforms = ['iPhone', 'iPod', 'iPad', 'Android'];
  if (bannerPlatforms.indexOf(platform) !== -1) {
    return true;
  }
  return false;
}

const initBranch = () => new Promise((resolve, reject) => {
  require('branch-sdk').default;
  const configData = JSON.parse(document.getElementById('configData').textContent);
  const branchKey = configData.analytics.branch;
  window.branch.init(branchKey, {}, (err, data) => {
    if (err) {
      reject(err);
      return;
    }
    resolve(window.branch);
  });
});

const getBranch = async () => {
  if (isClient()) {
    if (typeof window.branch !== 'undefined') {
      // Branch has been initialised already
      return window.branch;
    }
    return await initBranch();
  }
  return false;
};

const sendSMS = async (number, deeplink, referrer, callback) => {
  const branch = await getBranch();

  if (branch) {
    branch.sendSMS(number, {
      data: {
        '$deeplink_path': deeplink,
        'referring_user': referrer,
      },
    }, {
      make_new_link: true,
    }, callback);
  }
};

const createLink = async (linkPath, refer, params, callback) => {
  const branch = await getBranch();

  if (branch) {
    branch.link({
      ...params,
      data: {
        'referring_user': refer,
        '$deeplink_path': linkPath,
      },
    }, function(err, link) {
      if (link) {
        callback(link);
        return true;
      }
      console.error(err);
      return false;
    });
  }
};

export {
  sendSMS,
  createLink,
};



// WEBPACK FOOTER //
// ../src/client/utils/deeplinks.js